import { loginWrapper } from './ModuleWrapper.js';

import router from './router/Login.js';

const urlAddress = document.getElementById('view-data:ReturnUrl').value;
const authApiUrl = document.getElementById('view-data:AuthApiUrl').value;

loginWrapper('Login', router, urlAddress, authApiUrl).$mount('#app');
